import { ReactNode } from 'react'
import { Box } from '@mui/material'
import { PageHeader } from './PageHeader'

/**
 * A page in the shell: the sticky PageHeader (title, optional subtitle and
 * status, every page action) over a body at the content column's 24px
 * gutters. The body is a flex column, so a grid inside it takes the width and
 * height that are actually left.
 *
 * Replaced the old `Page` (36px inset) and `Supplyvue-ui/PageHeader`.
 */
export const PageLayout = ({
  title,
  subtitle,
  status,
  actions,
  children,
}: {
  title: string
  subtitle?: string
  status?: ReactNode
  actions?: ReactNode
  children?: ReactNode
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
    <PageHeader
      title={title}
      subtitle={subtitle}
      status={status}
      actions={actions}
    />
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        p: '24px',
      }}
    >
      {children}
    </Box>
  </Box>
)
